<template>
  <div>
    <div
      v-if="tree.children && tree.children.length > 0"
      style="position: relative"
    >
      <div>
        <div
          v-for="(child, childIndex) in tree.children"
          :key="childIndex"
          class="percentages-container"
        >
          <div class="textClass">
            <div class="textName">
              {{ child.evaluation_administrator_node_nomenclature }}
              {{ child.evaluation_administrator_node_requirementName }}
            </div>
            <div class="textPercetage">
              ({{ getChildPercentage(child).toFixed(2) }} % )
            </div>
          </div>
          <div
            class="percentage"
            :class="
              'percentage-' + Math.ceil(getChildPercentage(child).toFixed(2))
            "
          />
        </div>
      </div>
      <div>
        <div class="blank-ticks"></div>
      <div class="ticks">
        <div
          v-for="(tick, tickIndex) in [0, 20, 40, 60, 80, 100]"
          :key="tickIndex"
          class="tick"
          :class="'tick-'+tick"
        >
          <p>{{ tick }}</p>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  name: "EvaluationReportTreeListGraph",
  props: {
    tree: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {};
  },
  methods: {
    getChildPercentage(child) {
      if (!child.children || !child.children.length) {
        return child.evaluation_status ? child.evaluation_status : 0;
      } else {
        return child.evaluation_status &&
          child.evaluation_administrator_node_percentualWeight
          ? (child.evaluation_status * 100) /
              child.evaluation_administrator_node_percentualWeight
          : 0;
      }
    },
  },
};
</script >

<style lang="scss" scoped>

@import "../../../../assets/css/variables";

h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}
dl {
  display: flex;
  background-color: white;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0px;
}

dt {
  align-self: flex-start;
  width: 100%;
  font-weight: 700;
  display: block;
  text-align: center;
  font-size: 1.2em;
  font-weight: 700;
  margin-bottom: 20px;
  margin-left: 130px;
}

dd {
  margin-bottom: 0px;
}
.textClass {
  font-weight: 600;
  display: inline-flex;
  text-align: right;
  align-items: center;
  width: 50%;
  background-color: white;
  border-right: 2px solid black;
  min-height: 40px;
  vertical-align: middle;
}
.textName {
  padding-right: 15px;
  display: inline-block;
  width: 80%;
  vertical-align: middle;
  font-weight: normal;
}
.textPercetage {
  white-space: nowrap;
  display: inline-block;
  width: 20%;
  text-align: center;
  vertical-align: middle;
}
.percentage {
  font-size: 0.8em;
  line-height: 1;
  text-transform: uppercase;
  width: 50%;
  height: 40px;
  display: inline-block;
  vertical-align: middle;

  &:after {
    content: "";
    display: block;
    background-color: $primary-color;
    width: 50px;
    margin-bottom: 10px;
    height: 90%;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    transition: background-color 0.3s ease;
  }
}
.ticks {
  display: inline-block;
  width: 50%;
  border-top: 2px solid black;
  position: relative;
  top: -17px;
}
@for $i from 0 through 100 {
  .percentage-#{$i} {
    &:after {
      $value: ($i * 1%);
      width: $value;
    }
  }
}
.blank-ticks {
  display: inline-block;
  width: 50%;
}

@for $i from 0 through 100 {
  .tick-#{$i} {
    position: absolute;
    left: #{$i+'%'};
  }
}
.tick{
  transform: translateX(-50%);
}
</style >
